import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatTRACSDate',
    standalone: false
})
export class FormatTRACSDatePipe extends DatePipe implements PipeTransform {
  constructor() {
    super('en-US');
  }

  transform(value: number, ...args: any[]): any {
    return !value ? 'Unknown' : super.transform(value * 1000);
  }

}
